import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-purple px-3 py-4 sm:px-6" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pjg1tq2s8nvn">
        <h2 className="text-center text-[1.15rem] font-extrabold uppercase text-white sm:text-[1.75rem]" data-id="element-20" data-mp="avcx0k0h7i8f">
          🎁 5 professional bonuses included
        </h2>
        <div className="mt-2 space-y-2" data-id="element-21" data-mp="fsbt383p9z99">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-md border-l-4 border-gold bg-white px-2.5 py-2 shadow-sm" data-id="element-22" data-mp="1tlq5bu795cz">
              <h3 className="font-body text-[0.7rem] font-extrabold uppercase leading-tight tracking-wide text-navy sm:text-[0.88rem]" data-id="element-23" data-mp="3o1v84n1sa6su">
                🎁 Bonus {bonus.number} — {bonus.title}
              </h3>
              <p className="mt-0.5 text-[0.68rem] font-semibold text-purple sm:text-[0.8rem]" data-id="element-24" data-mp="1m9yv18zywovy">
                {bonus.subtitle}
              </p>
              <p className="mt-1 text-[0.78rem] leading-[1.35] sm:text-[0.92rem]" data-id="element-25" data-mp="1r8jtp3zkn0ia">
                {bonus.body}
              </p>
              <p className="mt-1 text-[0.66rem] font-bold uppercase tracking-wide text-teal sm:text-[0.78rem]" data-id="element-26" data-mp="3dfd5ls9xsgx3">
                {bonus.steps}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}